import { render, staticRenderFns } from "./ApprovalFlow.vue?vue&type=template&id=e260818c&scoped=true&"
import script from "./ApprovalFlow.vue?vue&type=script&lang=ts&"
export * from "./ApprovalFlow.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalFlow.vue?vue&type=style&index=0&id=e260818c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e260818c",
  null
  
)

export default component.exports